<template>
  <!-- 显示单个定位的地图组件 -->
  <div id="showMap"></div>
</template>

<script>
// window.onload = function () {
//   function init() {
//     var myLatlng = new qq.maps.LatLng(-34.397, 150.644);
//     var myOptions = {
//       zoom: 10,
//       center: myLatlng,
//       mapTypeId: qq.maps.MapTypeId.ROADMAP,
//       // 设置地图样式
//     };
//     var map = new qq.maps.Map(document.getElementById("container"), myOptions);
//   }
//   init();
// };
//
let marker
export default {
  name: 'show-location-on-map',
  data() {
    return {
      map: {},
      lat: this.latprop,
      lng: this.lngprop,
    }
  },
  props: {
    latprop: {
      type: Number,
      default: 32.07068252054583,
    },
    lngprop: {
      type: Number,
      default: 118.76962035751308,
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let center = new TMap.LatLng(this.lat, this.lng)
      //初始化地图
      this.map = new TMap.Map('showMap', {
        zoom: 12, //设置地图缩放级别
        mapStyleId: 'style1',
        center: center, //设置地图中心点坐标
      })
      // 去掉比例尺
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE)
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION)
    },
    pointerOnMap() {
      // 创建一个点标记
      let pointerOnMap = new TMap.LatLng(this.lat, this.lng)
      if (marker) {
        // 清除点标记
        marker.setMap(null)
        marker = null
      }
      // 创建点标记实例
      marker = new TMap.MultiMarker({
        map: this.map,
      })
      marker.add({ position: pointerOnMap })
      // 设置中心
      this.map.setCenter(pointerOnMap)
    },
  },
}
</script>

<style>
#showMap {
  width: 360px;
  height: 300px;
}
</style>